import { render } from "./VideoPage.vue?vue&type=template&id=7c51fd17"
import script from "./VideoPage.vue?vue&type=script&lang=js"
export * from "./VideoPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/wallace/Desktop/projects/virtap/virtap-webapp-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__